<template>
	<div class="col-lg-12">
		<dynvibebasechart
			:id="axiosComputed"
			ref="basechart"
			@created="chartCreated"
			:functionClick="clickGraph"
			:type="type"
		></dynvibebasechart>
		<input class="range-slider" type="range" v-model="currentIndex" :min="min" :max="max" />
	</div>
</template>
<script>
import graphMixin from "@/mixins/graphMixin.js";

export default {
	name: "dynvibeBarChartRace",
	mixins: [graphMixin],
	props: {
		legend: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			baseChart: undefined,
			allSeries: [],
			currentSeries: [],
			currentIndex: 0,
			allLabels: [],
			min: 0,
			max: 0,
		};
	},
	mounted() {
		setTimeout(() => {
			this.baseChart = this.$refs.basechart;
			this.setChartOptions();
		}, 1250);
	},
	methods: {
		setChartOptions() {
			if (!this.baseChart) {
				this.baseChart = this.$refs.basechart;
			}
			if (!this.$refs.basechart) {
				return;
			}

			let chartOptions = this.baseChart.getChartOptions();
			chartOptions.chart.type = "bar";
			chartOptions.xAxis = {
				type: "category",
				min: 0,
				labels: {
					animate: true,
				},
			};

			this.baseChart.updateChartOptions(chartOptions);
		},

		loadChartData(results) {
			if (!this.baseChart) {
				this.baseChart = this.$refs.basechart;
			}

			this.allSeries = results.values.data;
			let noData = this.allSeries.length === 0;
			this.baseChart.setNoData(noData);
			this.allLabels = results.labels;
			this.currentIndex = 0;
			this.min = 0;
			this.max = this.allSeries.length - 1;

			this.updateData();

			this.$emit("graphloaded");

			let intervalId = setInterval(() => {
				this.currentIndex += 1;
				if (this.currentIndex === this.allSeries.length - 1) {
					window.clearInterval(intervalId);
				}
			}, 2000);
		},
		updateData() {
			if (this.allSeries.length === 0) {
				return;
			}
			if (this.currentIndex > this.allSeries.length - 1) {
				return;
			}
			let chartOptions = this.baseChart.getChartOptions();
			this.currentSeries = this.allSeries[this.currentIndex];
			this.currentSeries = this.currentSeries.sort(function (a, b) {
				return a[0] - b[0];
			});
			this.currentSeries = this.currentSeries.slice(0, 20);

			chartOptions.series = [
				{
					name: this.allLabels[this.currentIndex].gte + " to " + this.allLabels[this.currentIndex].lte,
					zoneAxis: "x",
					zones: [
						{
							value: 1,
							color: "#33d1cd",
						},
					],
					dataLabels: {
						enabled: true,
					},
					dataSorting: {
						enabled: true,
						sortKey: "y",
					},
					data: this.currentSeries,
				},
			];
		},
	},
	watch: {
		noData: function () {
			if (this.noData == true) this.$emit("graphloaded");
			console.log("noData watch");
		},
		currentIndex: function () {
			this.updateData();
		},
	},
};
</script>
<style scoped></style>
